import { render, staticRenderFns } from "./RepresentativeApply.vue?vue&type=template&id=4afa9cde&scoped=true"
import script from "./RepresentativeApply.vue?vue&type=script&lang=js"
export * from "./RepresentativeApply.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeApply.vue?vue&type=style&index=0&id=4afa9cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa9cde",
  null
  
)

export default component.exports